/* FreeAir page script. Loaded only by layout/vf-freeair.liquid. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('fa-config');
  var CFG = cfgEl ? JSON.parse(cfgEl.textContent) : null;
  var root = document.documentElement;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = function (cents) {
    if (!cents) return CFG && CFG.strings ? CFG.strings.free : 'FREE';
    var v = (cents / 100).toFixed(2);
    return '$' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  var moneyPlain = function (cents) { var v = (cents / 100).toFixed(2); return '$' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };

  /* ---------- free-claim window: 3 hours per visitor, kept across reloads ---------- */
  var claim = { exp: 0, expired: false };
  (function initClaim() {
    var minS = (CFG && CFG.timer ? CFG.timer.minSeconds : 9900), maxS = (CFG && CFG.timer ? CFG.timer.maxSeconds : 10770);
    var key = 'fa_claim_exp_' + (CFG ? CFG.productId : 'x');
    var saved = parseInt(store.get(key), 10);
    if (saved && saved > 0) { claim.exp = saved; }
    else {
      var span = Math.max(0, maxS - minS);
      claim.exp = Date.now() + (minS + Math.floor(Math.random() * (span + 1))) * 1000;
      store.set(key, String(claim.exp));
    }
  })();
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var left = Math.max(0, Math.floor((claim.exp - Date.now()) / 1000));
    var h = Math.floor(left / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
    var txt = pad(h) + ':' + pad(m) + ':' + pad(s);
    $$('[data-fa-timer]').forEach(function (el) { el.textContent = txt; });
    $$('[data-fa-timer-h]').forEach(function (el) { el.textContent = pad(h); });
    $$('[data-fa-timer-m]').forEach(function (el) { el.textContent = pad(m); });
    $$('[data-fa-timer-s]').forEach(function (el) { el.textContent = pad(s); });
    var was = claim.expired;
    claim.expired = left <= 0 || soldOut();
    if (claim.expired !== was) { root.classList.toggle('fa-claim-ended', claim.expired); if (CFG) render(); }
  }

  /* ---------- free batch stock: real Shopify inventory, never invented ---------- */
  function stockLeft() { return CFG && CFG.stock && CFG.stock.tracked ? CFG.stock.left : null; }
  function soldOut() { var l = stockLeft(); return !!(CFG && CFG.stock && CFG.stock.endOnZero && l !== null && CFG.stock.started && l <= 0); }
  function paintStock() {
    var l = stockLeft();
    var show = l !== null && l > 0 && l <= (CFG.stock.showAt || 50);
    $$('[data-fa-stock]').forEach(function (el) {
      el.hidden = !show;
      var n = el.querySelector('[data-fa-stock-n]'); if (n && show) n.textContent = l;
      var bar = el.querySelector('[data-fa-stock-bar]');
      if (bar && show && CFG.stock.batch > 0) { bar.style.width = Math.max(4, Math.min(100, Math.round(l / CFG.stock.batch * 100))) + '%'; }
    });
  }

  if (!CFG) { setInterval(tick, 1000); tick(); }

  /* ---------- offer state ---------- */
  var state, FL = [];
  if (CFG) {
    CFG.flavors.forEach(function (f) { FL.push(f.name); });
    state = {
      tier: CFG.preselect || 'free',
      flavor: CFG.defaultFlavor || FL[0],
      picks: [],
      addons: {},
      touched: false
    };
    var startIdx = Math.max(0, FL.indexOf(state.flavor));
    state.picks = [FL[startIdx], FL[(startIdx + 1) % FL.length], FL[(startIdx + 2) % FL.length]];
  }
  function variantFor(offer, flavor) {
    for (var i = 0; i < CFG.variants.length; i++) {
      var v = CFG.variants[i];
      if (v.o === offer && (flavor == null || v.f === flavor)) return v;
    }
    for (var j = 0; j < CFG.variants.length; j++) if (CFG.variants[j].o === offer) return CFG.variants[j];
    return null;
  }
  function offerValue(tier) {
    if (tier === 'free') return claim.expired ? CFG.offers.single : CFG.offers.free;
    if (tier === 'three') return CFG.offers.three;
    return CFG.offers.seven;
  }
  function tierVariant(tier) {
    var o = offerValue(tier);
    if (tier === 'seven') return variantFor(o, CFG.offers.allFlavors);
    if (tier === 'three') return variantFor(o, state.picks[0] || state.flavor);
    return variantFor(o, state.flavor);
  }
  function addonsTotal() { var t = 0; CFG.addons.forEach(function (a) { if (state.addons[a.id]) t += a.price; }); return t; }
  function total() { var v = tierVariant(state.tier); return (v ? v.price : 0) + addonsTotal(); }

  function render() {
    if (!CFG) return;
    var offer = $('#fa-offer');
    if (offer) {
      ['free', 'three', 'seven'].forEach(function (t) { offer.classList.toggle('is-' + t, state.tier === t); });
      offer.classList.toggle('is-expired', claim.expired);
    }
    $$('[data-fa-tier]').forEach(function (b) {
      var t = b.dataset.faTier, on = t === state.tier;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      var v = tierVariant(t);
      if (!v) return;
      var p = b.querySelector('[data-fa-row-price]'); if (p) p.textContent = money(v.price);
      var w = b.querySelector('[data-fa-row-was]');
      if (w) { if (v.compare > v.price) { w.hidden = false; w.textContent = moneyPlain(v.compare); } else { w.hidden = true; } }
      if (t === 'free') {
        var nm = b.querySelector('[data-fa-row-name]'), sb = b.querySelector('[data-fa-row-sub]');
        if (nm) nm.textContent = claim.expired ? CFG.strings.singleName : CFG.strings.freeName;
        if (sb) sb.textContent = claim.expired ? CFG.strings.singleSub : CFG.strings.freeSub;
      }
    });
    /* flavor chips */
    var mode = state.tier === 'seven' ? 'all' : (state.tier === 'three' ? 'multi' : 'single');
    var picker = $('#fa-flavors');
    if (picker) {
      picker.dataset.mode = mode;
      $$('[data-fa-flavor]', picker).forEach(function (c) {
        var f = c.dataset.faFlavor, idx = state.picks.indexOf(f), on;
        if (mode === 'all') on = true; else if (mode === 'multi') on = idx > -1; else on = f === state.flavor;
        c.setAttribute('aria-checked', on ? 'true' : 'false');
        c.disabled = mode === 'all';
        var n = c.querySelector('[data-fa-pick-n]'); if (n) n.textContent = (mode === 'multi' && idx > -1) ? (idx + 1) : '';
      });
      var lab = $('[data-fa-flavor-label]', picker);
      if (lab) {
        if (mode === 'all') lab.textContent = CFG.strings.allLabel;
        else if (mode === 'multi') lab.textContent = CFG.strings.multiLabel.replace('{n}', state.picks.length);
        else lab.textContent = CFG.strings.singleLabel.replace('{f}', state.flavor);
      }
    }
    var v = tierVariant(state.tier);
    var now = $('[data-fa-price]'); if (now && v) now.textContent = money(v.price);
    var was = $('[data-fa-was]'), save = $('[data-fa-save]');
    if (v && v.compare > v.price) {
      if (was) { was.hidden = false; was.textContent = moneyPlain(v.compare); }
      if (save) { save.hidden = false; save.textContent = CFG.strings.save.replace('{x}', moneyPlain(v.compare - v.price)); }
    } else { if (was) was.hidden = true; if (save) save.hidden = true; }
    $$('.fa-addon').forEach(function (b) { b.setAttribute('aria-pressed', state.addons[b.dataset.addon] ? 'true' : 'false'); });
    $$('[data-fa-total]').forEach(function (el) { el.textContent = money(total()); });
    var lbl = claim.expired ? CFG.strings.atcPaid : (state.tier === 'free' ? CFG.strings.atcFree : CFG.strings.atcPack);
    $$('[data-fa-atc-label]').forEach(function (el) { el.textContent = lbl; });
    var vi = $('input[name="id"][data-fa-variant-input]'); if (vi && v) vi.value = v.id;
  }

  function scrollToOffer() {
    var box = document.getElementById('fa-offer');
    if (box) box.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  }

  if (CFG) {
    $$('[data-fa-tier]').forEach(function (b) {
      b.addEventListener('click', function () { state.tier = b.dataset.faTier; state.touched = true; render(); });
    });
    $$('[data-fa-select-tier]').forEach(function (b) {
      b.addEventListener('click', function () { state.tier = b.dataset.faSelectTier; state.touched = true; render(); if (!b.closest('#fa-offer')) scrollToOffer(); });
    });
    $$('[data-fa-flavor]').forEach(function (c) {
      c.addEventListener('click', function () {
        var f = c.dataset.faFlavor;
        state.touched = true;
        if (state.tier === 'seven') return;
        if (state.tier === 'three') {
          var i = state.picks.indexOf(f);
          if (i > -1) { if (state.picks.length > 1) state.picks.splice(i, 1); }
          else if (state.picks.length < 3) state.picks.push(f);
          else { state.picks[2] = f; }
          state.flavor = state.picks[0];
        } else {
          state.flavor = f;
          var k = state.picks.indexOf(f); if (k > 0) { state.picks.splice(k, 1); state.picks.unshift(f); } else if (k < 0) { state.picks[0] = f; }
        }
        render();
      });
    });
    $$('.fa-addon').forEach(function (b) {
      b.addEventListener('click', function () { state.addons[b.dataset.addon] = !state.addons[b.dataset.addon]; render(); });
    });
  }

  /* ---------- cart ---------- */
  function drawer() { return document.querySelector('cart-drawer'); }
  function sectionIds() { var d = drawer(); return d && d.getSectionsToRender ? d.getSectionsToRender().map(function (s) { return s.id; }) : []; }
  function setCount(n) { $$('[data-fa-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; }); }
  function base() { return CFG.routes.root; }
  function fetchCart() { return fetch(base() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function post(path, body) {
    return fetch(base() + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.text().then(function (t) { var j; try { j = JSON.parse(t); } catch (e) { throw new Error(CFG.strings.error); } if (!r.ok || j.status) throw new Error(j.description || j.message || CFG.strings.error); return j; }); });
  }
  function paintDrawer(j, open, btn) {
    var d = drawer();
    if (!d || typeof d.renderContents !== 'function') { if (open) window.location.href = CFG.routes.cart; return; }
    if (j && j.sections) d.renderContents(j);
    if (typeof j.item_count === 'number') d.classList.toggle('is-empty', j.item_count === 0);
    if (open && typeof d.open === 'function' && !d.classList.contains('active')) d.open(btn);
  }
  function vipFirst() {
    var sheet = document.querySelector('.vf-root'), bag = drawer();
    if (!sheet || !bag || sheet.classList.contains('open')) return;
    var hide = { visibility: 'hidden', opacity: '0', 'pointer-events': 'none', transition: 'none' };
    Object.keys(hide).forEach(function (k) { bag.style.setProperty(k, hide[k], 'important'); });
    var ticks = 0, tm = setInterval(function () {
      if (sheet.classList.contains('open') || ++ticks >= 15) { clearInterval(tm); Object.keys(hide).forEach(function (k) { bag.style.removeProperty(k); }); }
    }, 100);
  }
  function freeIds() { return CFG.variants.filter(function (v) { return v.o === CFG.offers.free; }).map(function (v) { return v.id; }); }

  /* The free carry kit follows the breather (one per order, plus the gift code) and the free claim stays at one per order. */
  var syncing = null;
  function syncCart() {
    if (!CFG) return Promise.resolve(null);
    if (syncing) return syncing;
    syncing = fetchCart().then(function (cart) {
      var hasMain = cart.items.some(function (i) { return i.product_id === CFG.productId; });
      var code = (CFG.giftCode || '').toUpperCase();
      var codes = (cart.discount_codes || []).map(function (c) { return c.code; });
      var others = codes.filter(function (c) { return c.toUpperCase() !== code; });
      var hasCode = codes.length !== others.length;
      var updates = {}, change = false;
      var fids = freeIds(), freeSeen = 0;
      cart.items.forEach(function (i) {
        if (fids.indexOf(i.variant_id) > -1) {
          var want = freeSeen >= 1 ? 0 : 1;
          if (i.quantity !== want) { updates[i.key] = want; change = true; }
          freeSeen += Math.min(1, i.quantity);
        }
      });
      if (hasMain) {
        CFG.gifts.forEach(function (g) {
          var lines = cart.items.filter(function (i) { return i.variant_id === g.id; });
          if (!lines.length) { updates[g.id] = 1; change = true; }
          lines.forEach(function (l, k) { var want = k === 0 ? 1 : 0; if (l.quantity !== want) { updates[l.key] = want; change = true; } });
        });
      } else {
        var giftIds = CFG.gifts.map(function (g) { return g.id; });
        cart.items.forEach(function (i) { if (giftIds.indexOf(i.variant_id) > -1 || (i.properties && i.properties._gift === 'freeair')) { updates[i.key] = 0; change = true; } });
      }
      var wantCode = hasMain && code;
      if (!change && (wantCode ? hasCode : !hasCode)) { setCount(cart.item_count); return cart; }
      var body = { updates: updates, sections: sectionIds(), sections_url: window.location.pathname };
      body.discount = others.concat(wantCode ? [CFG.giftCode] : []).join(',');
      return post('cart/update.js', body).then(function (j) { paintDrawer(j, false); setCount(j.item_count); return j; });
    }).catch(function () { return null; }).then(function (c) { syncing = null; return c; });
    return syncing;
  }

  function cartItems(inCart) {
    var v = tierVariant(state.tier);
    var main = { id: v.id, quantity: 1 };
    if (state.tier === 'three') {
      var picks = state.picks.slice();
      for (var i = 0; picks.length < 3 && i < FL.length; i++) if (picks.indexOf(FL[i]) < 0) picks.push(FL[i]);
      main.properties = {}; main.properties[CFG.strings.flavorsProp] = picks.join(', ');
    }
    var items = [main];
    CFG.addons.forEach(function (a) { if (state.addons[a.id]) items.push({ id: a.id, quantity: 1 }); });
    CFG.gifts.forEach(function (g) { if (!inCart[g.id]) items.push({ id: g.id, quantity: 1, properties: { _gift: 'freeair' } }); });
    return items;
  }

  function addToCart(btn) {
    var errs = $$('[data-fa-error]');
    errs.forEach(function (e) { e.hidden = true; });
    var buttons = $$('[data-fa-add]');
    buttons.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
    return fetchCart().then(function (cart) {
      var inCart = {};
      cart.items.forEach(function (i) { inCart[i.variant_id] = (inCart[i.variant_id] || 0) + i.quantity; });
      var items = cartItems(inCart);
      /* one free claim per order */
      if (freeIds().indexOf(items[0].id) > -1 && freeIds().some(function (id) { return inCart[id]; })) items.shift();
      var d = drawer();
      if (d && d.setActiveElement) d.setActiveElement(btn);
      if (!items.length) return { ok: true, body: { items: [] } };
      return fetch(CFG.routes.add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: sectionIds(), sections_url: window.location.pathname })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); });
    }).then(function (res) {
      if (!res.ok || res.body.status) throw new Error(res.body.description || res.body.message || CFG.strings.error);
      vipFirst();
      if (res.body.sections) paintDrawer(res.body, false);
      return syncCart().then(function (c) {
        return (c && typeof c.item_count === 'number' ? Promise.resolve(c) : fetchCart()).then(function (cc) {
          setCount(cc.item_count);
          paintDrawer({ item_count: cc.item_count }, true, btn);
        });
      });
    }).catch(function (e) {
      var msg = (e && e.message) ? e.message : CFG.strings.error;
      if (CFG.draft && CFG.strings.draft && /variant/i.test(msg)) msg = CFG.strings.draft;
      errs.forEach(function (el) { el.textContent = msg; el.hidden = false; });
      if (btn && !btn.closest('#fa-offer')) scrollToOffer();
    }).then(function () {
      buttons.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
    });
  }

  var offerSeen = false;
  if (CFG) {
    $$('[data-fa-add]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (b.dataset.faAddTier) { state.tier = b.dataset.faAddTier; render(); }
        if (b.hasAttribute('data-fa-scroll-first') && !offerSeen && !state.touched) { scrollToOffer(); return; }
        addToCart(b);
      });
    });
    $$('[data-fa-open-cart]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        var d = drawer();
        if (!d || typeof d.open !== 'function') return;
        e.preventDefault();
        Promise.all([fetch(base() + '?sections=' + sectionIds().join(',')).then(function (r) { return r.json(); }), fetchCart()]).then(function (res) {
          d.renderContents({ id: 0, sections: res[0] });
          paintDrawer({ item_count: res[1].item_count }, true, b);
        }).catch(function () { d.open(b); });
      });
    });
    syncCart();
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { clearTimeout(window.__faSync); window.__faSync = setTimeout(syncCart, 300); });
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('cart-remove-button, .quantity__button')) setTimeout(syncCart, 1400);
    });
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('cart-drawer [name="checkout"], cart-drawer a[href$="/checkout"]');
      if (!b || b.dataset.faReady === '1') return;
      e.preventDefault(); e.stopImmediatePropagation();
      syncCart().then(function () { var n = document.querySelector('cart-drawer [name="checkout"]') || b; n.dataset.faReady = '1'; n.click(); delete n.dataset.faReady; });
    }, true);
    $$('.fa-buy__proofrow .ceyla-rproof__text').forEach(function (p) {
      Array.prototype.forEach.call(p.childNodes, function (n) { if (n.nodeType === 3 && n.textContent.trim() === ',') n.textContent = ' '; });
    });
  }

  /* ---------- gallery ---------- */
  var track = $('.fa-gallery__track');
  var slides = track ? $$('.fa-gallery__slide', track) : [];
  var thumbs = $$('.fa-thumb');
  var current = 0;
  function go(i, smooth) {
    if (!track || !slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth && !reduced ? 'smooth' : 'auto' });
  }
  function mark(i) {
    current = i;
    thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    var t = thumbs[i];
    if (t && t.parentNode) { var p = t.parentNode; p.scrollTo({ left: t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2, behavior: reduced ? 'auto' : 'smooth' }); }
    slides.forEach(function (s, k) { var v = s.querySelector('video'); if (!v) return; if (k === i) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else { v.pause(); } });
  }
  if (track) {
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { var i = Math.round(track.scrollLeft / track.clientWidth); if (i !== current) mark(i); ticking = false; });
    }, { passive: true });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i, true); mark(i); }); });
    var prev = $('.fa-gallery__nav--prev'), next = $('.fa-gallery__nav--next');
    if (prev) prev.addEventListener('click', function () { go(current - 1, true); });
    if (next) next.addEventListener('click', function () { go(current + 1, true); });
    mark(0);
  }

  /* ---------- shipping dates (local calendar days) ---------- */
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function addDays(d, n) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); x.setDate(x.getDate() + n); return x; }
  function fmt(d) { return MONTHS[d.getMonth()] + ' ' + d.getDate(); }
  function fmtRange(a, b) { return a.getMonth() === b.getMonth() ? fmt(a) + '-' + b.getDate() : fmt(a) + ' - ' + fmt(b); }
  var lastDay = '';
  function dates() {
    if (!CFG) return;
    var now = new Date(), key = now.toDateString();
    if (key === lastDay) return; lastDay = key;
    var s = CFG.ship;
    $$('[data-fa-date="order"]').forEach(function (el) { el.textContent = fmt(now); });
    $$('[data-fa-date="ship"]').forEach(function (el) { el.textContent = fmt(addDays(now, s.ship)); });
    $$('[data-fa-date="deliver"]').forEach(function (el) { el.textContent = fmtRange(addDays(now, s.min), addDays(now, s.max)); });
  }
  dates();
  document.addEventListener('visibilitychange', function () { if (!document.hidden) { dates(); tick(); } });
  window.addEventListener('pageshow', function () { dates(); tick(); });
  setInterval(dates, 60000);

  /* ---------- dialogs ---------- */
  $$('[data-fa-dialog]').forEach(function (b) {
    b.addEventListener('click', function () { var dlg = document.getElementById(b.dataset.faDialog); if (dlg && dlg.showModal) dlg.showModal(); });
  });
  $$('.fa-dialog').forEach(function (dlg) {
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    var x = dlg.querySelector('.fa-dialog__x'); if (x) x.addEventListener('click', function () { dlg.close(); });
  });

  /* ---------- scroll links ---------- */
  $$('[data-fa-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.querySelector(a.getAttribute('href'));
      if (!t) return; e.preventDefault();
      t.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    });
  });

  /* ---------- sticky bar and sample pill ---------- */
  var sticky = $('.fa-sticky'), hero = $('.fa-hero'), mainAtc = $('.fa-atc'), closeSec = $('.fa-close');
  if (sticky && 'IntersectionObserver' in window) {
    var heroVis = true, atcVis = false, closeVis = false;
    var upd = function () { sticky.classList.toggle('is-on', !heroVis && !atcVis && !closeVis); };
    if (hero) new IntersectionObserver(function (en) { heroVis = en[0].isIntersecting; upd(); }).observe(hero);
    if (mainAtc) new IntersectionObserver(function (en) { atcVis = en[0].isIntersecting; if (atcVis) offerSeen = true; upd(); }).observe(mainAtc);
    if (closeSec) new IntersectionObserver(function (en) { closeVis = en[0].isIntersecting; upd(); }).observe(closeSec);
  }
  var offerBox = document.getElementById('fa-offer');
  if (offerBox && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { if (en[0].isIntersecting) offerSeen = true; }).observe(offerBox);
  }
  var banner = $('.fa-disclose'), pill = $('.fa-pill');
  if (banner && pill && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { pill.classList.toggle('is-on', !en[0].isIntersecting); }).observe(banner);
  }

  /* ---------- craving timer demo ---------- */
  $$('.fa-crave').forEach(function (box) {
    var btn = $('[data-fa-crave-start]', box), ring = $('[data-fa-crave-ring]', box), clock = $('[data-fa-crave-clock]', box);
    var stage = $('[data-fa-crave-stage]', box), stages = $$('[data-fa-crave-step]', box);
    var len = parseInt(box.dataset.seconds || '240', 10), speed = reduced ? 1 : parseInt(box.dataset.speed || '8', 10);
    var timer = null, startAt = 0;
    var C = ring ? 2 * Math.PI * parseFloat(ring.getAttribute('r')) : 0;
    if (ring) { ring.style.strokeDasharray = C; ring.style.strokeDashoffset = 0; }
    function show(sec) {
      var left = Math.max(0, len - sec), m = Math.floor(left / 60), s = Math.floor(left % 60);
      if (clock) clock.textContent = m + ':' + pad(s);
      if (ring) ring.style.strokeDashoffset = C * (sec / len);
      var p = sec / len, k = p < 0.34 ? 0 : (p < 0.67 ? 1 : (p < 1 ? 2 : 3));
      stages.forEach(function (el, i) { el.classList.toggle('is-on', i === k); el.classList.toggle('is-done', i < k); });
      if (stage && stages[k]) stage.textContent = stages[k].dataset.label || '';
      box.classList.toggle('is-done', p >= 1);
    }
    function run() {
      clearInterval(timer); startAt = Date.now(); box.classList.add('is-running');
      if (btn) btn.textContent = btn.dataset.again || btn.textContent;
      timer = setInterval(function () {
        var sec = Math.min(len, (Date.now() - startAt) / 1000 * speed);
        show(sec);
        if (sec >= len) { clearInterval(timer); box.classList.remove('is-running'); }
      }, 100);
    }
    if (btn) btn.addEventListener('click', run);
    show(0);
  });

  /* ---------- reveals (content stays visible without JS) ---------- */
  if (!reduced && 'IntersectionObserver' in window) {
    root.classList.add('fa-js');
    var rio = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); rio.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.fa-reveal').forEach(function (el) { rio.observe(el); });
    setTimeout(function () { $$('.fa-reveal').forEach(function (el) { el.classList.add('is-in'); }); }, 6000);
  }

  if (CFG) { paintStock(); }
  tick();
  setInterval(tick, 1000);
  if (CFG) render();
})();
